const setupInitialTree = folders => {
    // Filter out trashed folders as a safety measure
    const activeFolders = folders.filter(folder => !folder.deletedAt);
    
    let result = serializeArray(activeFolders);

    let justArrayOfChildren = mapArray(activeFolders);

    let setUpRootObject = () => {
        return {
            id: 'root',
            children: justArrayOfChildren,
            hasChildren: true,
            isExpanded: true,
            isChildrenLoading: false,
            data: {
                title: 'root'
            }
        };
    };

    let setupItems = () => {
        let root = setUpRootObject();
        return {
            root,
            ...result
        };
    };

    const treeData = {
        rootId: 'root',
        items: setupItems()
    };

    return sanitizeTreeData(treeData);
};

const serializeArray = folders => {
    let result = folders.reduce(function (map, folder) {
        map[folder.id] = {
            id: folder.id,
            children: [],
            hasChildren: true,
            isExpanded: false,
            isChildrenLoading: false,
            data: folder
        };
        return map;
    }, {});
    return result;
};

const mapArray = folders => {
    let result = folders.map(folder => {
        return folder.id;
    });
    return result;
};

const sanitizeTreeData = treeData => {
    if (!treeData || !treeData.items) {
        return treeData;
    }

    const rootId = String(treeData.rootId || 'root');
    const normalizedItems = Object.entries(treeData.items).reduce((acc, [itemId, item]) => {
        if (!item) {
            return acc;
        }

        const normalizedId = String(item.id || itemId);
        acc[normalizedId] = {
            ...item,
            id: normalizedId,
            children: Array.isArray(item.children)
                ? item.children.map(childId => String(childId))
                : [],
            hasChildren: Boolean(item.hasChildren),
            isExpanded: Boolean(item.isExpanded),
            isChildrenLoading: Boolean(item.isChildrenLoading),
            data: item.data || {}
        };

        return acc;
    }, {});

    if (!normalizedItems[rootId]) {
        normalizedItems[rootId] = {
            id: rootId,
            children: [],
            hasChildren: false,
            isExpanded: true,
            isChildrenLoading: false,
            data: {
                title: 'root'
            }
        };
    }

    Object.values(normalizedItems).forEach(item => {
        const uniqueValidChildren = item.children.filter((childId, index, children) => {
            return childId !== item.id && children.indexOf(childId) === index && Boolean(normalizedItems[childId]);
        });

        item.children = uniqueValidChildren;
        item.hasChildren = Boolean(item.hasChildren || uniqueValidChildren.length > 0);
    });

    const pruneCycles = (itemId, ancestors = new Set()) => {
        const item = normalizedItems[itemId];
        if (!item) {
            return [];
        }

        const nextAncestors = new Set(ancestors);
        nextAncestors.add(itemId);

        item.children = item.children.filter(childId => {
            if (nextAncestors.has(childId)) {
                return false;
            }

            pruneCycles(childId, nextAncestors);
            return true;
        });

        item.hasChildren = Boolean(item.hasChildren || item.children.length > 0);
        return item.children;
    };

    pruneCycles(rootId);

    return {
        ...treeData,
        rootId,
        items: normalizedItems
    };
};

export { setupInitialTree, serializeArray, mapArray, sanitizeTreeData };
